import HomeIcon from "~/app/_components/icon/service-icons/home";
import CommunityIcon from "~/app/_components/icon/service-icons/community";
import AccommodationIcon from "~/app/_components/icon/service-icons/accommodation";
import TransportIcon from "~/app/_components/icon/service-icons/transport";
import SupportIcon from "~/app/_components/icon/service-icons/support";
import Link from "next/link";
import {
  PersonalAndInHomeService,
  CommunityEngagementService,
  SupportCoordinationService,
  AccommodationService,
  TransportService,
} from "./navLinks";

export const SERVICE_LIST = {
  personal: {
    name: "Personal and In-Home Care Support",
    href: PersonalAndInHomeService.href,
    icon: HomeIcon,
    service: [
      {
        name: "Personal Care",
        description:
          " Assistance with activities such as bathing, dressing, and grooming.",
      },
      {
        name: "Household Tasks",
        description: "Help with cleaning, cooking, and other domestic chores.",
      },
      {
        name: "Travel and Transport",
        description:
          " Support with transportation to appointments or community activities.",
      },
      {
        name: "Community Participation",
        description:
          "Assistance with engaging in social and community activities.",
      },
      {
        name: "Life Skill Development",
        description: "Support in building skills for greater independence.",
      },
      {
        name: "Garden Maintenance:",
        description: "Help with outdoor tasks such as gardening.",
      },
      {
        name: "Housekeeping",
        description: "General upkeep and maintenance of the home.",
      },
    ],
  },
  support: {
    name: "Support Coordination",
    href: SupportCoordinationService.href,
    icon: SupportIcon,
  },
  community: {
    name: "Community Engagement",
    href: CommunityEngagementService.href,
    icon: CommunityIcon,
  },
  accommodation: {
    name: "Accommodation and Supported Independent Living (SIL)",
    href: AccommodationService.href,
    icon: AccommodationIcon,
  },
  transport: {
    name: TransportService.name,
    href: TransportService.href,
    icon: TransportIcon,
  },
};

export type IconLinkProps = {
  service?: any;
  name?: string | JSX.Element;
  fontClass?: string;
  iconClass?: string;
  iconSize?: string;
  iconColor?: string;
  borderColour?: string;
  order?: string;
  border?: "hideOnMobile" | boolean;
  customSize?: string;
};

export const SERVICE_ICON_LINK = ({
  borderColour,
  service,
  name,
  border,
  ...props
}: IconLinkProps) => {
  const fontClass = `text-[1.35rem]/7 lg:text-[1.65rem]/8 font-bold mt-1 ${props.fontClass ?? "text-white"}`;
  return (
    <>
      <div
        className={`${props.customSize ?? "h-full"} justify-center rounded-xl px-2 py-6 hover:bg-black/15 ${border === "hideOnMobile" ? "sm:border-[3px]" : border ? "border-[3px]" : ""} ${borderColour ?? ""}`}
      >
        <Link href={service.href} className="text-center">
          <service.icon
            fill={props.iconColor}
            className={`mx-auto ${props.iconSize ?? "h-8 w-8 lg:h-9 lg:w-9"} ${props.iconClass ?? ""}`}
          />
          {name ? (
            <div className={fontClass}>
              <>{name}</>
            </div>
          ) : typeof name === "string" ? (
            <p className={fontClass}>{name}</p>
          ) : (
            <p className={fontClass}>{service.name}</p>
          )}
        </Link>
      </div>
    </>
  );
};

export const SERVICE_PERSONAL_ICON_LINK = ({
  borderColour,
  border,
  ...props
}: IconLinkProps) => {
  return (
    <SERVICE_ICON_LINK
      service={SERVICE_LIST.personal}
      borderColour={borderColour}
      border={border}
      customSize={props.customSize}
      fontClass={props.fontClass}
      iconClass={props.iconClass}
      iconSize={props.iconSize}
      iconColor={props.iconColor}
      name={
        <p>
          Personal & In-Home
          <span className="block">Care Support</span>
        </p>
      }
    />
  );
};

export const SERVICE_SUPPORT_ICON_LINK = ({
  borderColour,
  border,
  ...props
}: IconLinkProps) => {
  return (
    <SERVICE_ICON_LINK
      service={SERVICE_LIST.support}
      borderColour={borderColour}
      border={border}
      customSize={props.customSize}
      fontClass={props.fontClass}
      iconClass={props.iconClass}
      iconSize={props.iconSize}
      iconColor={props.iconColor}
      name={
        <p>
          Support <span className="block">Coordination</span>
        </p>
      }
    />
  );
};

export const SERVICE_COMMUNITY_ICON_LINK = ({
  borderColour,
  border,
  ...props
}: IconLinkProps) => {
  return (
    <SERVICE_ICON_LINK
      service={SERVICE_LIST.community}
      borderColour={borderColour}
      border={border}
      customSize={props.customSize}
      fontClass={props.fontClass}
      iconClass={props.iconClass}
      iconSize={props.iconSize}
      iconColor={props.iconColor}
      name={
        <p>
          Community <span className="block">Engagement</span>
        </p>
      }
    />
  );
};

export const SERVICE_ACCOMMODATION_ICON_LINK = ({
  borderColour,
  border,
  ...props
}: IconLinkProps) => {
  return (
    <SERVICE_ICON_LINK
      service={SERVICE_LIST.accommodation}
      borderColour={borderColour}
      border={border}
      customSize={props.customSize}
      fontClass={props.fontClass}
      iconClass={props.iconClass}
      iconSize={props.iconSize}
      iconColor={props.iconColor}
      name={
        <p>
          Accommodation <span className="block">& SIL</span>
        </p>
      }
    />
  );
};

export const SERVICE_TRANSPORT_ICON_LINK = ({
  borderColour,
  border,
  ...props
}: IconLinkProps) => {
  return (
    <SERVICE_ICON_LINK
      service={SERVICE_LIST.transport}
      borderColour={borderColour}
      border={border}
      customSize={props.customSize}
      fontClass={props.fontClass}
      iconClass={props.iconClass}
      iconSize={props.iconSize}
      iconColor={props.iconColor}
    />
  );
};
